import {isNil} from 'ramda';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';
import {Button, Icon} from 'semantic-ui-react';
import styled, {css} from 'styled-components';
import {BRIGHT_RED, DARK_GREEN, CHARCOAL} from '../Container/ContainerMix';

const FabUl = styled.ul`
  border-radius: 10px 10px 0 0;
  padding: 20px 0 0 0;
  background-color: #fff;
  margin: 0 0 0 0;
  list-style: none;
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  animation: slide-up 0.3s ease;
  
  @keyframes slide-up {
    0% {
        opacity: 0;
        transform: translateY(20px);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
  }
`;

const FabLi = styled.li`
  width: 100%;
`;

const CloseButtonWrapper = styled(FabLi)`
  display: flex;
  justify-content: flex-end;
  > button {
    width: 60px;
    padding: 0 10px 10px 0!important;
    height: 60px;
    display: flex !important;
    & > i {
      margin: 0 !important;
    }
  }
`;

const MenuButton = styled(Button)`
  width: 100%;
  border-radius: 0 !important;
  text-align: left !important;
  background-color: rgb(255, 255, 255) !important;
  display: flex !important;
  flex-direction: row;
  align-items: center;
  padding: 0 20px !important;
  height: 45px;
  @media (max-height: 568px) {
    font-size: 1rem !important;
  }
`;

const InnerWrapper = styled.span`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex: 1;
`;

const CloseButton = styled(MenuButton)`
  text-align: right !important;
  padding-right: 15px !important;
  padding-bottom: 30px !important;
  font-size: 2rem !important;
`;

const CloseIcon = styled(Icon)`
`;

const FloatingButton = styled(Button)`
  right: 0px;
  bottom: 15px;
  background: none;
  border: none;
  z-index: 1000;
  position: fixed;
  // This fixed the position fixed issue in iOS devices (we need to confirm this is working in android)
  // Adding the 3D transformation triggers the GPU acceleration making for a smooth transition. */
  transform: translate3d(0,0,0);
  
  width: 80px;
  height: 80px;
  padding: 0 !important;
  box-shadow: 0 2px 0 0 rgba(0,0,0,0.3) !important;
  border: 4px solid #ffffff !important;
  background-image: linear-gradient(180deg, #0A8EE2 0%, #05CFEC 100%) !important;
  color: rgba(255, 255, 255, .95) !important;
  font-size: 29px !important;
  font-family: Roboto,arial,san serif !important;
  ${props => props.incompleteActivities && css`
    &:before{
      content:'';
      background-color: ${BRIGHT_RED};
      height: 20px;
      width: 20px;
      border-radius: 50%;
      position: absolute;
      top: 0;
      left: 0;
    }
  `}
  @media (max-height: 568px) {
    width: 60px;
    height: 60px;
    font-size: 24px !important;
  }
`;

const CompleteIconWrapper = styled.div`
  background-color: #00DC83;
  border: 2px solid #ffffff;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 15px;
  box-shadow: 0 2px 0 0 rgba(0,0,0,0.3) !important;
  & > i {
    color: #009532;
    font-size: .6em;
    padding: 0;
    margin: 0;
    line-height: initial;
  }
`;

const CompleteIcon = styled(Icon)`
  color: ${DARK_GREEN};
`;

const IncompleteIcon = styled(Icon)`
  color: ${CHARCOAL};
`;

const FullWidthIcon = styled(Icon)`
  text-align: right !important;
`;

const StyledIcon = styled(Icon)`
  margin: 0em 0rem 0em 0em !important;
  color: #ffffff;
  opacity: 1 !important;
`;

const BackgroundMask = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background-color: rgba(0,0,0,0.5);
  transition: background 1s ease-in-out;
`;

class FloatingActionButton extends Component {
  constructor() {
    super();
    this.state = {
      isMenuOpen: false,
      isStressProfileMenuOpen: false
    };
  }

  toggleMenu = () => {
    this.setState({isMenuOpen: !this.state.isMenuOpen});
  };

  toggleStressProfileMenu = () => {
    // we want to toggle the main menu during this time too.  that makes it so that:
    // 1) when sp menu is opened, we hide the main menu options
    // 2) when sp menu is closed, we go back to showing main menu options
    this.toggleMenu();
    this.setState({isStressProfileMenuOpen: !this.state.isStressProfileMenuOpen});
  };

  render() {
    const {isMenuOpen, isStressProfileMenuOpen} = this.state;
    const {activities, incompleteActivities, router} = this.props;

    const onAddActivity = type => () => router.push(`/activities/${type}`);

    const onUpdateStressProfile = type => () => router.push(`/stress/${type}`);

    const hasLoggedActivityType = type => activities.filter(a => a.activity_type === type).length > 0;
  
    const hasLoggedStressActivityType = propertyKey => {
      const stressActivity = activities.find(a => a.activity_type === 'stress');
      if (isNil(stressActivity)) {
        return false;
      }
      const property = stressActivity.properties.find(p => p.property_key === propertyKey);
      return !isNil(property) && property.property_value > 0;
    };

    const hasLoggedAllStressTypes = () => {
      const stressActivity = activities.find(a => a.activity_type === 'stress');
      if (isNil(stressActivity) || stressActivity.properties.length !== 5) {
        return false;
      }

      return stressActivity.properties.every(p => hasLoggedStressActivityType(p.property_key));
    };
    
    const getStressMenuIcon = propertyKey => hasLoggedStressActivityType(propertyKey) ?
      <CompleteIconWrapper><CompleteIcon name="check "/></CompleteIconWrapper> :
      <IncompleteIcon name="circle outline"/>;
    
    const getMenuIcon = type => hasLoggedActivityType(type) ?
      <CompleteIconWrapper><CompleteIcon name="check"/></CompleteIconWrapper> :
      <IncompleteIcon name="circle outline"/>;

    return (
      <div>
        {(isMenuOpen || isStressProfileMenuOpen) && <BackgroundMask/>}
        {
          isMenuOpen && (
            <FabUl>
              <FabLi>
                <MenuButton size="huge" onClick={this.toggleStressProfileMenu}>
                  {hasLoggedAllStressTypes() ? <CompleteIconWrapper><CompleteIcon name="check "/></CompleteIconWrapper> : <IncompleteIcon name="circle outline"/>}
                  <InnerWrapper>Stress
                    <FullWidthIcon name="chevron right"/>
                  </InnerWrapper>
                </MenuButton>
              </FabLi>
              <FabLi>
                <MenuButton size="huge" onClick={onAddActivity('sleep')}>
                  {getMenuIcon('sleep')}
                  <InnerWrapper>Sleep</InnerWrapper>
                </MenuButton>
              </FabLi>
              <FabLi>
                <MenuButton size="huge" onClick={onAddActivity('water')}>
                  {getMenuIcon('water')}
                  <InnerWrapper>Water</InnerWrapper>
                </MenuButton>
              </FabLi>
              <FabLi>
                <MenuButton size="huge" onClick={onAddActivity('fitness')}>
                  {getMenuIcon('fitness')}
                  <InnerWrapper>Physical Activity</InnerWrapper>
                </MenuButton>
              </FabLi>
              <FabLi>
                <MenuButton size="huge" onClick={onAddActivity('food')}>
                  {getMenuIcon('food')}
                  <InnerWrapper>Food/Substance</InnerWrapper>
                </MenuButton>
              </FabLi>
              <FabLi>
                <MenuButton size="huge" onClick={onAddActivity('rest')}>
                  {getMenuIcon('rest')}
                  <InnerWrapper>Rest/Mindfulness</InnerWrapper>
                </MenuButton>
              </FabLi>
              <FabLi>
                <MenuButton size="huge" onClick={onAddActivity('sunshine')}>
                  {getMenuIcon('sunshine')}
                  <InnerWrapper>Sunshine</InnerWrapper>
                </MenuButton>
              </FabLi>
              <FabLi>
                <MenuButton size="huge" onClick={onAddActivity('hygiene')}>
                  {getMenuIcon('cleanliness')}
                  <InnerWrapper>Hygiene</InnerWrapper>
                </MenuButton>
              </FabLi>
              <CloseButtonWrapper>
                <CloseButton size="huge" onClick={this.toggleMenu}>
                  <CloseIcon name="close"/>
                </CloseButton>
              </CloseButtonWrapper>
            </FabUl>
          )
        }
        {
          isStressProfileMenuOpen && (
            <FabUl>
              <FabLi>
                <MenuButton size="huge" onClick={onUpdateStressProfile('people')}>
                  {getStressMenuIcon('people')}
                  <InnerWrapper>Social</InnerWrapper>
                </MenuButton>
              </FabLi>
              <FabLi>
                <MenuButton size="huge" onClick={onUpdateStressProfile('money')}>
                  {getStressMenuIcon('money')}
                  <InnerWrapper>Financial</InnerWrapper>
                </MenuButton>
              </FabLi>
              <FabLi>
                <MenuButton size="huge" onClick={onUpdateStressProfile('personal')}>
                  {getStressMenuIcon('personal')}
                  <InnerWrapper>Emotional/Mental</InnerWrapper>
                </MenuButton>
              </FabLi>
              <FabLi>
                <MenuButton size="huge" onClick={onUpdateStressProfile('clock')}>
                  {getStressMenuIcon('clock')}
                  <InnerWrapper>Time Management</InnerWrapper>
                </MenuButton>
              </FabLi>
              <FabLi>
                <MenuButton size="huge" onClick={onUpdateStressProfile('health')}>
                  {getStressMenuIcon('health')}
                  <InnerWrapper>Physical</InnerWrapper>
                </MenuButton>
              </FabLi>
              <CloseButtonWrapper>
                <CloseButton size="huge" onClick={this.toggleStressProfileMenu}>
                  <CloseIcon name="close"/>
                </CloseButton>
              </CloseButtonWrapper>
            </FabUl>
          )
        }
        <FloatingButton size="large" circular onClick={this.toggleMenu} incompleteActivities={incompleteActivities}>
          <StyledIcon size="large" name="plus"/>
        </FloatingButton>
      </div>
    );
  }
}

FloatingActionButton.propTypes = {
  activities: PropTypes.array.isRequired,
  router: PropTypes.object.isRequired,
  incompleteActivities: PropTypes.bool.isRequired
};

export default withRouter(FloatingActionButton);



// WEBPACK FOOTER //
// ./src/components/Button/FloatingActionButton.js